<template>
<!-- a big round gauge to show percentage complete -->
    <div class="container mt-5">
        &nbsp;

<h1 class="mt-5">Restart Progress</h1>
        <h1>{{ complete.toFixed(2) }}%</h1>
        <div class="row mt-5 justify-content-center align-content-center ">
            <div class="col-sm-4  border-1 border-dark p-0" style="border-radius: 4%">
                <b-progress-bar :value="complete" variant="success" height="2rem" show-progress animated></b-progress-bar>
            </div>
        </div>
        <p class="mt-5">For the network to restart we need 80% of active stake online. There is currently {{ status }}% of active stake visible in gossip.<br>As more validators complete their restart this number will rise in line with the amount of stake they have delegated: this means larger validators such as CEX have an outsized impact on restart times.</p>
        <div class="card text-left">
            <div class="card-body">
                <h3>Incident 2023-02-25</h3>
                <p>
                    The network experienced a significant slowdown in block production that coincided with an upgrade to validator software. Engineers are still conducting a root cause analysis.
                </p>
                <p>
                    Initially validators decided to attempt a downgrade to version 1.13, but it was not sufficient to restore the network to normal operation, so the decision was made to restart the network on v1.13.6
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RestartStatus",

    data() {
        return {
            status: 0
        }
    },
    mounted() {
        // run the restart status function every 30 seconds
        setInterval(this.restartStatus, 30000);
        this.restartStatus()
    },
    methods: {
        restartStatus() {
            // get the restart status from the API
            axios.get('/restartStatus')
                .then(response => {
                    // update the restart status
                    this.status = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    computed: {
        complete() {
            // return the percentage complete
            return this.status / 80 * 100;
        }
    }
}
</script>

<style scoped>

</style>
